/* BKP UI: sitewide vormelementen
   - custom stepper (− / +) rond number-inputs in .bkp-wz__sizes en .bkp-form
   - voortgangsvulling voor range-sliders (--bkp-fill)
   Nieuwe elementen (bv. wizard her-render) worden automatisch opgepikt. */
(function () {
  'use strict';

  function stap(inp, richting) {
    var step = parseFloat(inp.step) || 1;
    var min = inp.min !== '' ? parseFloat(inp.min) : 0;
    var max = inp.max !== '' ? parseFloat(inp.max) : Infinity;
    var v = parseFloat(inp.value);
    if (isNaN(v)) v = 0;
    v = Math.min(max, Math.max(min, v + richting * step));
    inp.value = v;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // klik = 1 stap; vasthouden herhaalt (na 450ms, elke 110ms)
  function houdVast(btn, inp, richting) {
    var timer = null, interval = null;
    function start(e) {
      if (e.type === 'pointerdown' && e.button !== 0) return;
      stap(inp, richting);
      timer = setTimeout(function () {
        interval = setInterval(function () { stap(inp, richting); }, 110);
      }, 450);
    }
    function stop() { clearTimeout(timer); clearInterval(interval); timer = interval = null; }
    btn.addEventListener('pointerdown', start);
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { btn.addEventListener(ev, stop); });
    btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stap(inp, richting); } });
  }

  function maakStepper(inp) {
    if (inp.closest('.bkp-stepper')) return;
    var wrap = document.createElement('div');
    wrap.className = 'bkp-stepper';
    inp.parentNode.insertBefore(wrap, inp);
    var minBtn = document.createElement('button');
    minBtn.type = 'button'; minBtn.className = 'bkp-stepper__btn'; minBtn.setAttribute('aria-label', 'Minder'); minBtn.textContent = '−';
    var plusBtn = document.createElement('button');
    plusBtn.type = 'button'; plusBtn.className = 'bkp-stepper__btn'; plusBtn.setAttribute('aria-label', 'Meer'); plusBtn.textContent = '+';
    wrap.appendChild(minBtn); wrap.appendChild(inp); wrap.appendChild(plusBtn);
    houdVast(minBtn, inp, -1);
    houdVast(plusBtn, inp, 1);
  }

  function vulRange(r) {
    var min = parseFloat(r.min) || 0, max = parseFloat(r.max);
    if (isNaN(max)) max = 100;
    var v = parseFloat(r.value) || 0;
    var pct = max > min ? ((v - min) / (max - min)) * 100 : 0;
    r.style.setProperty('--bkp-fill', pct + '%');
  }

  // Foto-pijlen op productkaarten via een EIGEN overlay-afbeelding. De Horizon-
  // kaartslideshow staat op disabled en geeft niet-actieve slides breedte 0;
  // aria-hidden of comp.next() aansturen gaf daardoor witte beelden. De overlay
  // ligt over slide 1 heen en bladert zelf door alle media (index 0 = origineel).
  function kaartPijlen(gal) {
    if (gal.dataset.bkpArrows) return;
    var bronnen = [];
    gal.querySelectorAll('slideshow-slide img').forEach(function (im) {
      var src = im.getAttribute('src');
      if (src) bronnen.push({ src: src, srcset: im.getAttribute('srcset') || '', sizes: im.getAttribute('sizes') || '' });
    });
    if (bronnen.length < 2) return;
    gal.dataset.bkpArrows = '1';
    var idx = 0;
    var view = document.createElement('img');
    view.className = 'bkp-cardview';
    view.alt = '';
    view.hidden = true;
    gal.appendChild(view);
    function toon(i) {
      idx = (i + bronnen.length) % bronnen.length;
      if (idx === 0) { view.hidden = true; return; } // terug bij de originele foto
      var b = bronnen[idx];
      if (b.srcset) view.setAttribute('srcset', b.srcset); else view.removeAttribute('srcset');
      if (b.sizes) view.setAttribute('sizes', b.sizes); else view.removeAttribute('sizes');
      view.src = b.src;
      view.hidden = false;
    }
    [['prev', 'Vorige foto', 'M15 18l-6-6 6-6'], ['next', 'Volgende foto', 'M9 18l6-6-6-6']].forEach(function (def) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bkp-cardnav bkp-cardnav--' + def[0];
      b.setAttribute('aria-label', def[1]);
      b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + def[2] + '"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        toon(idx + (def[0] === 'next' ? 1 : -1));
      });
      gal.appendChild(b);
    });
  }

  // accordeons (productinfo + FAQ): grid-rows-techniek — de details staat altijd
  // open, zichtbaarheid via .is-open + een pure CSS-transitie (0fr -> 1fr).
  // Geen JS-timing, dus geen haperen of blijven hangen.
  function animeerAccordeon(det) {
    if (det.dataset.bkpAcc) return;
    det.dataset.bkpAcc = '1';
    var summary = det.querySelector('summary');
    var inhoud = summary ? summary.nextElementSibling : null;
    if (!summary || !inhoud) return;
    var wrap = document.createElement('div');
    wrap.className = 'bkp-acc';
    var inner = document.createElement('div');
    inner.className = 'bkp-acc__inner';
    det.insertBefore(wrap, inhoud);
    inner.appendChild(inhoud);
    wrap.appendChild(inner);
    det.classList.toggle('is-open', det.open);
    det.open = true;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      det.classList.toggle('is-open');
    });
  }

  // één kleurvolgorde overal: alfabetisch, in het filter én op de kaart-swatches
  function sorteerKleuren(root) {
    root.querySelectorAll('.facets__inputs-list').forEach(function (ul) {
      if (!ul.querySelector('.bkp-cf') || ul.dataset.bkpSorted) return;
      ul.dataset.bkpSorted = '1';
      var items = [].slice.call(ul.children);
      items.sort(function (a, b) {
        var an = (a.querySelector('.bkp-cf__input') || {}).dataset ? (a.querySelector('.bkp-cf__input').dataset.label || '') : '';
        var bn = (b.querySelector('.bkp-cf__input') || {}).dataset ? (b.querySelector('.bkp-cf__input').dataset.label || '') : '';
        return an.localeCompare(bn, 'nl');
      });
      items.forEach(function (li) { ul.appendChild(li); });
    });
    root.querySelectorAll('.bkp-cx__swatches').forEach(function (wrap) {
      if (wrap.dataset.bkpSorted) return;
      wrap.dataset.bkpSorted = '1';
      var dots = [].slice.call(wrap.querySelectorAll('.bkp-cx__dot'));
      dots.sort(function (a, b) { return (a.title || '').localeCompare(b.title || '', 'nl'); });
      var more = wrap.querySelector('.bkp-cx__more');
      dots.forEach(function (d) { wrap.insertBefore(d, more || null); });
    });
  }

  // klik buiten een open drawer (winkelwagen, menu, filters) sluit hem;
  // Horizon opent deze dialogs niet-modaal, dus zonder backdrop-klikgedrag
  document.addEventListener('pointerdown', function (e) {
    var dlg = document.querySelector('theme-drawer > dialog[open]');
    if (!dlg) return;
    if (e.target.closest('theme-drawer')) return; // klik in het paneel zelf
    if (e.target.closest('cart-icon, [aria-haspopup], [on\\:click]')) return; // opener-knoppen
    var r = dlg.getBoundingClientRect();
    if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) return;
    var td = dlg.closest('theme-drawer');
    if (td && typeof td.close === 'function') td.close();
    else {
      var btn = dlg.querySelector('.theme-drawer__close-button');
      if (btn) btn.click();
    }
  });

  // minimale afname bewaken in winkelwagen en drawer. De drempel geldt over de
  // HELE bestelling (mixen mag: 2 broeken + 3 shirts = 5), dus we tellen alle
  // regels bij elkaar op i.p.v. per ontwerp. Kant-en-klare artikelen (_bkp_min
  // van 1 of lager) en toeslagregels tellen niet mee: die mogen per stuk.
  // De checkout-Function is de server-side handhaving; dit is de nette UX-laag.
  // Bedrukkingsregels synchroon houden met de kleding. De meerprijs is per stuk,
  // dus wijzigt de klant een aantal in de winkelwagen, dan moet de toeslagregel
  // mee. Alleen corrigeren waar het afwijkt; wees-regels (ontwerp verwijderd)
  // gaan naar 0. De checkout-validatie is de harde vangnet-controle.
  var syncBezig = false;
  var drukVariantenCache = null;
  function drukVarianten() {
    if (drukVariantenCache) return Promise.resolve(drukVariantenCache);
    return Promise.all([
      fetch('/products/bkp-toeslag-bedrukking.js').then(function (r) { return r.json(); }),
      fetch('/products/bkp-toeslag-vectorisatie.js').then(function (r) { return r.json(); })
    ])
      .then(function (producten) {
        var map = {};
        (producten[0].variants || []).forEach(function (v) { map[(v.title || '').toLowerCase().trim()] = v.id; });
        if (producten[1].variants && producten[1].variants[0]) map.vectorisatie = producten[1].variants[0].id;
        drukVariantenCache = map;
        return map;
      })
      .catch(function () { return {}; });
  }
  function syncBedrukking(cart) {
    if (syncBezig) return Promise.resolve(false);
    var perOntwerp = {};
    (cart.items || []).forEach(function (i) {
      var p = i.properties || {};
      if (!p._bkp_design_id) return;
      var d = perOntwerp[p._bkp_design_id] || (perOntwerp[p._bkp_design_id] = { qty: 0, klein: 0, groot: 0, vectorisatie: 0 });
      d.qty += i.quantity;
      d.klein = parseInt(p._bkp_druk_klein, 10) || 0;
      d.groot = parseInt(p._bkp_druk_groot, 10) || 0;
      d.vectorisatie = Math.max(d.vectorisatie, parseInt(p._bkp_vect, 10) || 0);
    });
    // bestaande toeslagregels bijstellen (en wees-regels op 0 zetten)
    var wijzigingen = [];
    var aanwezig = {};
    (cart.items || []).forEach(function (i) {
      var p = i.properties || {};
      var klasse = p._bkp_klasse;
      if (!klasse && i.handle === 'bkp-toeslag-vectorisatie') klasse = 'vectorisatie';
      if (!klasse || !p._bkp_ref) return;
      aanwezig[p._bkp_ref + '|' + klasse] = true;
      var d = perOntwerp[p._bkp_ref];
      var gewenst = d ? (klasse === 'vectorisatie' ? d.vectorisatie : d.qty * (d[klasse] || 0)) : 0;
      var omschrijving = d && klasse !== 'vectorisatie'
        ? (d[klasse] || 0) + ((d[klasse] || 0) === 1 ? ' positie' : ' posities') + ' × ' + d.qty + ' kledingstukken'
        : (p.Berekening || p.Bedrukking);
      if (i.quantity !== gewenst || (klasse !== 'vectorisatie' && gewenst > 0 && p.Berekening !== omschrijving)) {
        var props = Object.assign({}, p);
        delete props.Bedrukking;
        if (klasse !== 'vectorisatie' && omschrijving) props.Berekening = omschrijving;
        wijzigingen.push({ id: i.key, quantity: gewenst, properties: props });
      }
    });
    // ontbrekende toeslagregels terugzetten: bedrukking hoort bij het ontwerp en
    // is niet los te verwijderen (anders zou de klant gratis bedrukking krijgen)
    var toevoegen = [];
    Object.keys(perOntwerp).forEach(function (ref) {
      var d = perOntwerp[ref];
      ['klein', 'groot', 'vectorisatie'].forEach(function (klasse) {
        var n = d[klasse] || 0;
        if (n > 0 && !aanwezig[ref + '|' + klasse]) {
          toevoegen.push({
            ref: ref,
            klasse: klasse,
            quantity: klasse === 'vectorisatie' ? n : d.qty * n,
            posities: n,
            stuks: d.qty
          });
        }
      });
    });
    if (!wijzigingen.length && !toevoegen.length) return Promise.resolve(false);
    syncBezig = true;
    var keten = wijzigingen.reduce(function (k, w) {
      return k.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(w)
        });
      });
    }, Promise.resolve());
    if (toevoegen.length) {
      keten = keten.then(drukVarianten).then(function (map) {
        var items = toevoegen.map(function (t) {
          return map[t.klasse] ? {
            id: map[t.klasse], quantity: t.quantity,
            properties: t.klasse === 'vectorisatie'
              ? { '_bkp_ref': t.ref }
              : {
                  '_bkp_ref': t.ref, '_bkp_klasse': t.klasse,
                  'Berekening': t.posities + (t.posities === 1 ? ' positie' : ' posities') + ' × ' + t.stuks + ' kledingstukken'
                }
          } : null;
        }).filter(Boolean);
        if (!items.length) return null;
        // tijdstempel in sessionStorage: de melding moet zowel de her-render als
        // het herladen van de winkelwagenpagina overleven
        try { sessionStorage.setItem('bkp-druk-hersteld', String(Date.now())); } catch (e) { /* optioneel */ }
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      });
    }
    return keten.then(function () {
      syncBezig = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // De winkelwagenpagina is server-gerenderd: na een correctie zou de klant
      // anders verouderde aantallen en een verkeerd totaal blijven zien. Eén keer
      // herladen per paginabezoek; daarna is de winkelwagen consistent en doet
      // een volgende sync niets meer (dus geen herlaadlus).
      if (!alGeherladen && /\/cart\/?$/.test(location.pathname)) {
        alGeherladen = true;
        location.reload();
      }
      return true;
    }).catch(function () { syncBezig = false; return false; });
  }
  // (herstelmelding loopt via sessionStorage, zie hierboven)
  var alGeherladen = false;

  var minCheckBezig = false;
  function bewaakMinAfname() {
    var knoppen = document.querySelectorAll('button[name="checkout"], #checkout, .cart__checkout-button');
    if (!knoppen.length || minCheckBezig) return;
    minCheckBezig = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      minCheckBezig = false;
      // eerst de bedrukkingsaantallen rechttrekken; daarna herbeoordeelt de
      // observer de winkelwagen opnieuw met de gecorrigeerde regels
      syncBedrukking(cart);
      var qty = 0, min = 0;
      // offerte-drempel per drempelgroep: producten met een ruimere drempel (bv.
      // stickers) mogen niet geblokkeerd worden door een strenger product ernaast
      var perDrempel = {};
      (cart.items || []).forEach(function (i) {
        var p = i.properties || {};
        var regelMin = parseInt(p._bkp_min, 10) || 0;
        if (regelMin <= 1) return; // los verkrijgbaar of geen wizard-regel
        qty += i.quantity;
        if (regelMin > min) min = regelMin;
        var regelMax = parseInt(p._bkp_max, 10) || 0;
        if (regelMax > 0) perDrempel[regelMax] = (perDrempel[regelMax] || 0) + i.quantity;
      });
      var fouten = [];   // blokkeren de afrekenknop
      var notities = []; // alleen uitleg, blokkeren niets
      var hersteld = 0;
      try { hersteld = parseInt(sessionStorage.getItem('bkp-druk-hersteld'), 10) || 0; } catch (e) { /* optioneel */ }
      if (hersteld && Date.now() - hersteld < 15000) {
        notities.push('Een gekoppelde toeslag hoorde bij je ontwerp en is opnieuw toegevoegd. Wil je je ontwerp aanpassen? Doe dat op de productpagina.');
      } else if (hersteld) {
        try { sessionStorage.removeItem('bkp-druk-hersteld'); } catch (e) { /* optioneel */ }
      }
      if (qty > 0 && qty < min) {
        fouten.push('Je bestelt vanaf ' + min + ' stuks per bestelling; er staan er nu ' + qty +
          ' in je winkelwagen. Mixen mag: vul aan met een ander product of verhoog het aantal.');
      }
      Object.keys(perDrempel).forEach(function (d) {
        var max = parseInt(d, 10), aantal = perDrempel[d];
        if (max > 0 && aantal > max) {
          fouten.push('Bij meer dan ' + max + ' stuks maken we een tarief op maat; er staan er nu ' + aantal +
            ' van dit soort artikelen in je winkelwagen. <a href="/pages/offerte-aanvragen">Vraag een offerte aan</a> of verlaag het aantal.');
        }
      });
      var meldingTekst = fouten.concat(notities).join(' ');
      document.querySelectorAll('button[name="checkout"], #checkout, .cart__checkout-button').forEach(function (b) {
        b.disabled = fouten.length > 0;
        b.classList.toggle('bkp-checkout-blocked', fouten.length > 0);
        var houder = b.closest('.cart__ctas, .cart__summary, form') || b.parentElement;
        var melding = houder.querySelector('.bkp-cart-minwarn');
        if (meldingTekst) {
          if (!melding) {
            melding = document.createElement('p');
            melding.className = 'bkp-cart-minwarn';
            b.parentElement.insertBefore(melding, b);
          }
          // alleen schrijven als de tekst echt wijzigt: elke innerHTML-write is een
          // DOM-mutatie die de MutationObserver opnieuw triggert (fetch-lus!)
          if (melding.dataset.msg !== meldingTekst) {
            melding.dataset.msg = meldingTekst;
            // eigen tekst (geen klantinvoer); één span omdat het blok flex is en
            // losse tekstnodes anders elk een eigen flex-item worden
            melding.innerHTML = '<span>' + meldingTekst + '</span>';
          }
        } else if (melding) {
          melding.remove();
        }
      });
    }).catch(function () { minCheckBezig = false; });
  }

  function scan(root) {
    root.querySelectorAll('.bkp-wz__sizes input[type="number"], .bkp-form input[type="number"]').forEach(maakStepper);
    root.querySelectorAll('input[type="range"]').forEach(vulRange);
    root.querySelectorAll('.product-card .card-gallery').forEach(kaartPijlen);
    root.querySelectorAll('.bkp-pi__item, .bkp-faq__item').forEach(animeerAccordeon);
    sorteerKleuren(root.querySelectorAll ? root : document);
    bewaakMinAfname();
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.type === 'range') vulRange(e.target);
  }, true);

  function init() {
    scan(document);
    new MutationObserver(function () { scan(document); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
